import Manager from 'coreClasses/Manager';
import {selectSpinnerStatus, receiveSpinnerStatus} from 'coreStore/data/ui';

/**
 * Represents SpinnerMgr
 */
class SpinnerMgr extends Manager {
	/**
	 * Show spinner
	 * @param {Boolean} showSpinner spinner flag
	 */
	show(showSpinner: boolean): void {
		const spinnerStatus = this.getSpinnerState();

		if (showSpinner === spinnerStatus) {
			return;
		}

		this.setSpinnerStatus(showSpinner);
	}

	/**
	 * Retrieves spinner state
	 * @returns {boolean}
	 */
	private getSpinnerState(): boolean {
		const store = this.managerRepository.getStoreMgr().getStore();

		return selectSpinnerStatus(store.getState());
	}

	/**
	 * Update spinner status
	 * @param {Boolean} showSpinner spinner flag
	 */
	private setSpinnerStatus(showSpinner: boolean): void {
		const store = this.managerRepository.getStoreMgr().getStore();

		// @ts-ignore
		store.dispatch(receiveSpinnerStatus({
			spinner: showSpinner
		}));
	}
}

export default SpinnerMgr;
